import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, empty, from } from 'rxjs';
import { OfficeService } from '../services/office.service';
import { Office } from '../classes/office';
import { PreRenderService } from '../services/pre-render.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class OfficeResolver implements Resolve<Office> {

  constructor(private _officeService: OfficeService, private _router: Router, private _preRenderService: PreRenderService) { }

  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot): Observable<Office> {
    const url = rstate.root.firstChild.url;

    let officeId = '';
    const officeIdRegex = /-(\w{0,1}\d*)-br$/g;

    const officeIdMatches = officeIdRegex.exec(url[1].path);
    if (officeIdMatches && officeIdMatches.length === 2) officeId = officeIdMatches[1];

    return from(this._officeService.getOfficeDetails(officeId, false))
    .pipe(catchError((err) => {
      this._router.navigate(['/find-agent-or-office/office']);
      this._preRenderService.setPreRenderFlag(301, 'find-agent-or-office/office');
      return empty();
    }));
  }
}
